import { env } from 'next-runtime-env';

export const ENV = {
  IS_DEVELOPMENT: process.env.NODE_ENV === 'development',
  IS_PRODUCTION: process.env.NODE_ENV === 'production',

  get BASE_PATH() {
    return env('NEXT_PUBLIC_BASE_PATH') ?? '';
  },
  get GATEWAY_URL() {
    return env('GATEWAY_URL') ?? '';
  },
  get AUTH_API_BASE_URL() {
    return env('NEXT_PUBLIC_AUTH_API_BASE_URL') ?? '';
  },
  get API_TIMEOUT() {
    return parseInt(env('NEXT_PUBLIC_API_TIMEOUT') ?? '20000');
  },
  get PROXY_TIMEOUT() {
    return this.API_TIMEOUT - 2000;
  },
  get COOKIE_KEY() {
    return env('NEXT_PUBLIC_COOKIE_KEY') ?? 'vsid';
  },
  get IS_SKIP_AUTH() {
    return env('NEXT_PUBLIC_SKIP_AUTH') ?? false;
  },
  get MOCK_ENABLED() {
    return env('NEXT_PUBLIC_MOCK_ENABLED') ?? false;
  },
  get APP_NAME() {
    return env('NEXT_PUBLIC_APP_NAME') ?? 'VAETKI Commerce';
  },
  get APP_VERSION() {
    // env() 는 동적 접근이라 next.config env 의 빌드타임 인라인이 적용되지 않는다.
    // 리터럴 참조 폴백으로 빌드에 구워진 pkg.version 이 노출되게 한다 (meta app-version).
    return (
      env('NEXT_PUBLIC_APP_VERSION') ??
      process.env.NEXT_PUBLIC_APP_VERSION ??
      '1.0.0'
    );
  },
  get MY_APP() {
    return env('NEXT_PUBLIC_MY_APP') ?? '';
  },
  get GTM_ID() {
    return 'GTM-MKZ2R6SQ';
  },
} as const;
